export default {
  methods: {

    validateRequestAsDraft () {
      this.swalConfirm({
        html: () => {
          if (this.editing) {
            return 'Update Draft?'
          }

          return 'Save ATW as Draft?'
        },
        customClass: {
          confirmButton: 'btn btn-sm btn-secondary'
        },
        preConfirm: () => {
          const createOrUpdate = () => {
            return this.editing ? this.updateDraft() : this.submitDraft()
          }

          return createOrUpdate().catch(
            errors => {
              if (errors.errors) {
                this.setProductErrors(errors.errors)
                this.$refs.formWithdrawal.setErrors(errors.errors)
                this.$refs.formStockRequest.setErrors(errors.errors)
              }
            }
          )
        },
        confirmButtonText: this.editing ? 'Update' : 'Save'
      })
    },

    submitDraft () {
      const { id, headers, pickup_details } = this.stockRequest
      return this.$refs.srDraft.create({
        id: id,
        headers: {
          withdrawal_type: headers.withdrawal_type,
          destination: headers.destination,
          destination_name: headers.destination_name,
          destination_code: headers.destination_code,
          supplier: headers.supplier,
          supplier_name: headers.supplier_name,
          supplier_code: headers.supplier_code,
          remarks: ''
        },
        pickup_details: {
          date: pickup_details.date,
          vehicle: pickup_details.vehicle,
          vehicle_plate: pickup_details.vehicle_plate,
          vehicle_name: pickup_details.vehicle_name,
          driver: pickup_details.driver,
          driver_name: pickup_details.driver_name,
          mobile_number: pickup_details.mobile_number,
          is_3pl: pickup_details.is_3pl,
          helper: pickup_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        is_draft: 1,
        active: 1
      }).then(() => {
        this.currentTabIndex = 1
      })
    },

    updateDraft (isDraft = 1, remarks = '') {
      const { id, headers, pickup_details } = this.stockRequest
      return this.$refs.srDraft.update({
        id: id,
        headers: {
          withdrawal_type: headers.withdrawal_type,
          destination: headers.destination,
          destination_name: headers.destination_name,
          destination_code: headers.destination_code,
          supplier: headers.supplier,
          supplier_name: headers.supplier_name,
          supplier_code: headers.supplier_code,
          remarks: remarks
        },
        pickup_details: {
          date: pickup_details.date,
          vehicle: pickup_details.vehicle,
          vehicle_plate: pickup_details.vehicle_plate,
          vehicle_name: pickup_details.vehicle_name,
          driver: pickup_details.driver,
          driver_name: pickup_details.driver_name,
          mobile_number: pickup_details.mobile_number,
          is_3pl: pickup_details.is_3pl,
          helper: pickup_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        is_draft: isDraft,
        active: 1
      }).then(() => {
        this.currentTabIndex = Number(isDraft)
      })
    }
  }
}
